import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import UseWalletConnectHook from 'hooks/useWalletconnect';
import { observer } from 'mobx-react';
import TransactionConfirmationModal from 'components/TransactionConfirmationModal';
import useTokenPrice from 'hooks/useTokenPrice';
import classNames from 'classnames';
import GlobalSimepleDialog from 'components/Dialog/GlobalSimpleDialog';
import UseGetGlobal from 'hooks/useGetGlobal';
import AppLoading from 'pages/AppLoading';
import GlobalAuthModal from 'pages/components/GlobalAuthModal';
import { GlobalResultDialog } from 'components/Dialog/GlobalResultDialog';
import storage from 'utils/storage';
import { socialAuthStorageKey, SocialType } from 'constant/socialAuth';
import { homePath } from 'constant/route-path';

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: auto;
    position: relative;
    background: #121212;

    &.landing-page::before {
        content: '';
        position: absolute;
        width: 100vw;
        height: 766px;
        background-image: linear-gradient(103.22deg, rgba(125, 56, 175, 0.46) 0%, rgba(247, 147, 26, 0.4) 94.36%),
            linear-gradient(180deg, rgba(18, 18, 18, 0) 61.6%, #121212 100%),
            image-set(url(${require('assets/images/home/explorebg.png')}) type('image/png'));
        background-size: cover;
        background-repeat: no-repeat;
        background-position: right bottom;
        pointer-events: none;
        background-blend-mode: color-dodge, color-dodge, normal;
    }
    &.landing-page::after {
        content: '';
        position: absolute;
        right: 0px;
        top: 180px;
        width: 154px;
        height: 284px;
        background-image: image-set(url(${require('assets/images/home/banner-rocket.png')}) type('image/png'));
        background-size: contain;
        background-repeat: no-repeat;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
        overflow-x: hidden;
        &.landing-page::before {
            height: 454px;
            background-image: 
            image-set(url(${require('assets/images/home/explorebgMobile.png')}) type('image/png'));
            background-size: contain, contain, contain;
            background-repeat: no-repeat;
            background-position: right bottom;
        }
        &.landing-page::after {
            display: none;
            background-image: none;
        }
    `};
`;

function App() {
    const location = useLocation();

    useTokenPrice();

    useEffect(() => {
        const container = document.getElementById('globalContainer');
        container?.scrollTo(0, 0);
    }, [location.pathname]);

    // process twitter auth redirect
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const twitter_auth = searchParams.get('twitter_auth');
        const discord_auth = searchParams.get('discord_auth');
        const stats = searchParams.get('stats');
        if (twitter_auth !== null) {
            try {
                storage.set(socialAuthStorageKey(SocialType.Twitter), { twitter_auth, stats });
            } catch (error) {
                console.error('localstorage error:', error);
            }
        }
        if (discord_auth !== null) {
            try {
                storage.set(socialAuthStorageKey(SocialType.Discord), { discord_auth, stats });
            } catch (error) {
                console.error('localstorage error:', error);
            }
        }
    }, [location.search]);

    return (
        <>
            <UseGetGlobal />
            <UseWalletConnectHook />
            <GlobalAuthModal />
            <TransactionConfirmationModal />
            <Container
                id="globalContainer"
                className={classNames('container', {
                    'landing-page': location.pathname === homePath,
                })}
            >
                <AppLoading />
            </Container>
            <GlobalSimepleDialog />
            <GlobalResultDialog />
        </>
    );
}

export default observer(App);
